import View from './reviews-view';

export default View;
